import type { Product } from "@jti/magento";

import type { SummaryItem } from "../../ItemsSummaryView";

const getCartItemPriceToUse = (cartItem: Product, showPricesWithTaxExcluded: boolean) => {
  return showPricesWithTaxExcluded ? cartItem.prices?.row_total : cartItem.prices?.row_total_including_tax;
};

export const mapSimpleProductToSummaryItem = (
  product: Product,
  isFreeTrial: boolean,
  showPricesWithTaxExcluded: boolean = false
): SummaryItem => {
  let badge: string | undefined;
  if (product.isGift) {
    badge = "cart.payment_summary.freeGift";
  } else if (isFreeTrial) {
    badge = "cart.payment_summary.freeTrials";
  }

  const priceToUse = getCartItemPriceToUse(product, showPricesWithTaxExcluded);

  return {
    type: "product",
    id: product.id ?? product.sku,
    item: {
      thumbnail: {
        src: product.imageUrl ?? "",
        alt: product.name,
      },
      title: product.name,
      spec: product.subtitle,
      badge: badge,
      quantity: product.quantity,
      price: {
        value: priceToUse?.value ?? 0,
        currency: priceToUse?.currency ?? "",
      },
      nicotineStrength: product.nicotineStrength,
    },
  };
};
